import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/ocean-pro-home-solar-battery';
import SEOlinksA from '@/components/SEOlinksA';
import OceanProHomeSolarBattery from '@elem/compPage/OceanProHomeSolarBattery';

export default function OceanProHomeSolarBatteryPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();

    const { t } = useLang('OceanProHomeSolarBattery');

    const router = useRouter();

    const { locale } = router;

    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    useEffect(() => {
        if (!seoconfig.include.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop theme="black">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <OceanProHomeSolarBattery />
        </PageLayout>
    );
}
